export const SLIDER_CONFIG = {
    autoSlide:      true,
    slideDuration:  5000,
    animationSpeed: 600,
    animationType:  'slide' as 'slide' | 'fade',
    showArrows:     true,
    showIndicators: true,
    infiniteLoop:   true,
    pauseOnHover:   true,
} as const;
